import React, {Component} from 'react'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Tabs, Typography, Spin, Row, Col, Table, Icon, Button, Form, Select, Avatar, message, Modal, Tooltip} from 'antd'
import { Queries, Mutations } from '../../../graphql'
import Container from '../../../components/user/Container'
import FromInput from '../../../components/user/from/Input'
import InputDateStartEnd from '../../../components/user/from/InputDateStartEnd'
import { changeFormatdate } from '../../../utils/formatdate'
import { numberWithCommas } from '../../../utils/number'
import { approveStatus } from '../../../utils/leave'
import DelegateFormModal from '../../../components/user/DelegateFormModal'
import moment from 'moment'
import { checkStatus, checkTypeDelegate } from '../../../utils/Delegate'
import { NIL } from 'uuid'

const { TabPane } = Tabs
const { Text, Title } = Typography
const { Option } = Select;

const newsDataProfile = '';

class Delegate extends Component {
	state = {
		loading:true,
		dataTalbe: [],
      columns: [
         {
               title: 'ลำดับ',
               dataIndex: 'docId',
               width:'10px',
         align:"center",
               render: (item, record, index) => <span>{ (this.state.pageData.offset+index) + 1}</span>
         },
         {
               title: 'ชื่อผู้รับมอบอำนาจ',
               dataIndex: 'userDelegateName',
         width:"200px",
               render: (item, record, index) => 	<span 
                                       onClick={ (e) => !record.isActive ? this.showModalNote(record) : '' }
                                       className={!record.isActive ? 'cursor-poiter' : ''}
                                    >
                                       { item }
                                    </span>
         },
      // {
      //        title: 'ประเภทคำขอ',
      // 	width:"200px",
      //        dataIndex: 'docType',
      // 	align:"center",
      //        render: (item, record, index) => 	<span 
      // 											onClick={ (e) => !record.isActive ? this.showModalNote(record) : '' }
      // 											className={!record.isActive ? 'cursor-poiter' : ''}
      // 										>
      // 											{ checkTypeDelegate(item) }
      // 										</span>
      //    },
      {
               title: 'วันที่สร้าง',
               dataIndex: 'startDate',
         width:"200px",
               render: (item, record, index) => 	<span 
                                       onClick={ (e) => !record.isActive ? this.showModalNote(record) : '' }
                                       className={!record.isActive ? 'cursor-poiter' : ''}
                                    >
                                       { changeFormatdate(item) }
                                    </span>
         },
      {
               title: 'วันที่เริ่มต้น',
               dataIndex: 'startDate',
         width:"200px",
               render: (item, record, index) => 	<span 
                                       onClick={ (e) => !record.isActive ? this.showModalNote(record) : '' }
                                       className={!record.isActive ? 'cursor-poiter' : ''}
                                    >
                                       { changeFormatdate(item) }
                                    </span>
         },
      {
               title: 'วันที่สิ้นสุด',
               dataIndex: 'endDate',
         width:"200px",
               render: (item, record, index) => <span 
                                       onClick={ (e) => !record.isActive ? this.showModalNote(record) : '' }
                                       className={!record.isActive ? 'cursor-poiter' : ''}
                                    >
                                       { changeFormatdate(item) }
                                    </span>
         },
         {
               title: 'สถานะ',
               dataIndex: 'isActive',
               width:"200px",
               align:"center",
               render: (item, record, index) => 	<span 
                                       onClick={ (e) => !record.isActive ? this.showModalNote(record) : '' }
                                       className={!record.isActive ? 'cursor-poiter' : ''}
                                    >
                                       { checkStatus(item) }
                                    </span>
         },
         {
               title: 'จัดการ',
               dataIndex: '7',
               width:'100px',
               fixed: 'right',
               align:"center",
               render: (item, record, index) => {
                  return <>
                     <Tooltip placement="top" title={"ทำการยกเลิกรายการมอบอำนาจ"} hidden>
                        <p 
                           onClick={ (e) => record.isActive ? this.showModalFormReject(record) : '' } 
                           style={{ display:"inline-block" }} className="mr-2"
                           hidden={ record.isActive == 1 ? false : true }
                        >
                           <Avatar 
                              shape="square" 
                              type="delete" 
                              size={64} 
                              icon="delete" 
                              size="small" 
                              className={record.isActive ? "custom-btn-icons" : "custom-btn-icons disble-tn"}
                              style={{ cursor:"pointer" }}
                           />
                        </p>
                     </Tooltip>

                     <Tooltip placement="top" title={"ดูหมายเหตุที่ยกเลิกรายการมอบอำนาจ"} hidden>
                        <p
                           onClick={ (e) => !record.isActive ? this.showModalNote(record) : '' }
                           className={!record.isActive ? 'cursor-poiter' : ''}
                           style={{ display:"inline-block" }}
                           hidden={ record.isActive == 0 ? false : true }
                        >
                           <Avatar 
                              shape="square" 
                              type="search" 
                              size={64} 
                              icon="search" 
                              size="small" 
                              className={!record.isActive ? "custom-btn-icons" : "custom-btn-icons disble-tn"}
                              style={{ cursor:"pointer" }}
                           />
                        </p>
                     </Tooltip>
                  </>
               }
         },
      ],
		pageData: {
            offset: 0,
            limit: 10
        },
        pagination: {
            total: 10,
        },
		visibleModal: false,
		detailModal:null,
		dataProfile:null,
		modalFormPage:null,
		delegateId:null,
		formSearch:null,
		visibleModalNote: false,
		titleModalNote: null,
		noteModalNote: null,
		modalTitleDelagateForm:null,
      dropdownlistDelegator:[],
      orgCode: null
	}

   checkShowI

	fetchListProfile = async () =>{
		const { client } = this.props
		try {
            const { date } = this.state
            const { data, errors } = await client.query({
                query: Queries.fetchProfile
            })
            
			if(data.fetchProfile){
				await this.setState({
					dataProfile:data.fetchProfile,
				})
			}else{
				await this.setState({
					dataProfile:null,
				})
			}
        } catch (error) {
			await this.setState({
				dataProfile:null,
			})
        }
		
	}

   fetchEmployeeDetail = async () => {
      const { client, location, match } = this.props
      const { dataProfile } = this.state
      const { data, errors } = await client.query({
          query: Queries.fetchEmployeeDetail,
          variables:{
            empCode: dataProfile.employeeCodes[0]
          }
      })

      if(data.fetchEmployeeDetail){
          await this.setState({
            orgCode: data.fetchEmployeeDetail.orgCode,
          })
      }else{
          await this.setState({
              detailProfile:null,
            //   loadingFullpage:false
          })
      }
  }

	fetchListDataTable = async () =>{
		const { client } = this.props

		await this.setState({
			loading:true
		})

		try {
            const { date } = this.state
            const { data, errors } = await client.query({
                query: Queries.fetchListDelegateApprover,
                variables:{
                  docType: "LEAVE",
                  isActive: null
                }
            })

            console.log('data.fetchListDelegateApprover', data.fetchListDelegateApprover)

			if(data.fetchListDelegateApprover){
				await this.setState({
					loading:false,
					dataTalbe:data.fetchListDelegateApprover,
					formSearch:null
				})
			}else{
				await this.setState({
					loading:false,
					dataTalbe:[],
					formSearch:null
				})
			}
			

        } catch (error) {
            // console.log(error)
			await this.setState({
				loading:false,
				dataTalbe:[],
			})
        }
		
	}

	fetchListDelegator = async () =>{
		const { client } = this.props
      const { orgCode, dataProfile } = this.state
		try {
            const { date } = this.state
            const { data, errors } = await client.query({
                query: Queries.fetchListDelegator,
               //  variables:{
               //    orgCode
               //  }
            })

         
			if(data.fetchListDelegator){
            const dropdownlistDelegator = data.fetchListDelegator.filter(valuesArray => valuesArray.empCode !== dataProfile.employeeCodes[0]);
            // const dropdownlistDelegator = data.fetchListDelegator;
				await this.setState({
					dropdownlistDelegator,
               loading: false
				})
			}else{
            await this.setState({
               loading: false
				})
         }

        } catch (error) {
			   console.log('asfdasfdsaf',error)
            await this.setState({
				   dropdownlistDelegator: [],
               loading: false
			   })
        }
	}

	fetchListDataTableSearch = async (values) =>{
		const { client, form } = this.props
			
		await this.setState({
			loading:true,
		})

		try {
			const { date } = this.state
			const { data, errors } = await client.query({
				query: Queries.fetchListDelegateApprover,
				variables: {
               docType: "LEAVE",
					...values
				}
			})

			console.log('fetchListDelegateApprover',data.fetchListDelegateApprover)

			if(data.fetchListDelegateApprover){
				await this.setState({
					loading:false,
					dataTalbe:data.fetchListDelegateApprover,
					formSearch:values
				})
			}else{
				await this.setState({
					loading:false,
					dataTalbe:[],
					formSearch:values
				})
			}

		} catch (error) {
			// console.log(error)
			await this.setState({
				loading:false,
				dataTalbe:[],
			})
		}
	}

	headSubmitSearch = async (e) =>{
		const { client, form } = this.props

		e.preventDefault()
		form.validateFields(async (err, values) => {
			console.log('values', values)
			try {
				this.fetchListDataTableSearch(values)
			} catch (error) {
				await this.setState({
					loading:false,
					dataTalbe:[],
				})
			}
		})
	}

	createDelegate = async (values) =>{
		const { client, form } = this.props
		const { dataProfile, formSearch } = this.state
		try {
			const { date } = this.state
			const { data, errors } = await client.query({
				query: Mutations.createDelegateApprover,
				variables: {
               docType: "LEAVE",
					fromEmpCode:dataProfile.employeeCodes[0],
					isActive:1,
					...values
				}
			})

			console.log('createDelegateApprover',data.createDelegateApprover)

			if(data.createDelegateApprover){
				await this.setState({
					visibleModal:false
				})

				if(formSearch){
					this.fetchListDataTableSearch(formSearch)
				}else{
					this.fetchListDataTable()
				}

                message.success('ทำการสร้างรายการมอบอำนาจเรียบร้อย')
			}else{
				await this.setState({
					// visibleModal:false
				})
			}
		} catch (error) {
			console.log(error)
		}
	}

	rejectDelegate = async (values) =>{
		const { client, form } = this.props
		const { delegateId, formSearch } = this.state
		try {
			const { date } = this.state
			const { data, errors } = await client.query({
				query: Mutations.revokeDelegateApprover,
				variables: {
					delegateId:delegateId,
					...values
				}
			})

			if(data.revokeDelegateApprover){
				await this.setState({
					visibleModal:false
				})

				if(formSearch){
					this.fetchListDataTableSearch(formSearch)
				}else{
					this.fetchListDataTable()
				}

                message.success('ทำการยกเลิกการมอบอำนาจสำเร็จ')
			}else{
				await this.setState({
					// visibleModal:false
				})
			}
		} catch (error) {
			console.log(error)
		}
	}

	showModalFormCreate = async () =>{
		await this.setState({
			visibleModal:true,
			modalFormPage:'createDelegate',
			modalTitleDelagateForm:"ยืนยันรายการมอบอำนาจ"
		})
	}

	showModalFormReject = async (record) =>{
		await this.setState({
			delegateId: record.delegateId,
			visibleModal:true,
			modalFormPage:'rejectDelegate',
			modalTitleDelagateForm:'ยืนยันการยกเลิกรายการมอบอำนาจ'
		})
	}

	showDetailFormModal = async () =>{
		await this.setState({
			visibleModal:true,
			detailModal:{},
		})
	}

	closeModal = async (values) =>{
		if(values){
			await this.setState({
				visibleModal:false,
				detailModal:null,
				modalTitleDelagateForm:null
			})
		}else{
			await this.setState({
				visibleModal:false,
				detailModal:null,
				modalTitleDelagateForm:null
			})
		}
	}

	showModalNote = async (record) =>{
		await this.setState({
			visibleModalNote:true,
			noteModalNote:record.note,
			titleModalNote: "หมายเหตุที่ยกเลิกรายการมอบอำนาจ"
		})
	}

	closeModalNote = async () =>{
		await this.setState({
			visibleModalNote:false,
			noteModalNote:null,
			titleModalNote: null
		})
	}

	async componentDidMount(){
		await this.fetchListProfile()
      await this.fetchEmployeeDetail()
		await this.fetchListDelegator()
		await this.fetchListDataTable()
    }

	render() {
		const { match } = this.props
		const { 
			dataTalbe, 
			columns, 
			loading, 
			pagination, 
			preLoadSubmit,
			visibleModal,
			detailModal,
			dataProfile,
			dropdownlistDelegator,
			modalFormPage,
			visibleModalNote,
			noteModalNote,
			titleModalNote,
			modalTitleDelagateForm
		} = this.state
		const { getFieldDecorator } = this.props.form;
        console.log('dataTalbe', dataTalbe)
		return (
			<Container match={match}>
				<DelegateFormModal 
					visibleModal={visibleModal} 
					detail={detailModal} 
					title= {modalTitleDelagateForm}
					closeModal={ this.closeModal } 
					createDelegate={this.createDelegate}
					modalFormPage={modalFormPage}
					rejectDelegate={this.rejectDelegate}
					dropdownlistDelegator={dropdownlistDelegator}
					dataProfile={dataProfile}
				/>
				<Modal
					visible={visibleModalNote}
					title={(
						<>
                            <strong className="color-red">
                                { titleModalNote }
                            </strong>
						</>
					)}
					onOk={
						() =>{
							// window.location.reload();
						}
					}
					onCancel={
						() =>{
							this.closeModalNote()
							// window.location.reload();
						}
					}
					width={600}
					footer={null}
               className="5412261"
            >   
					{noteModalNote}
				</Modal>
				<div className="card-container" id="page-profile">
					<div className="px-5 py-1 card-bg-green">
						<Form onSubmit={this.headSubmitSearch}>
							<Row gutter={16} type="flex" justify="left" align="top" className="box-color-white mb-0" >
								<Col xs={24} md={24} className="pt-2 mb-4">
									<strong className="color-red">
										ค้นหา
									</strong>
								</Col>
								{/* <Col xs={ 24 } md={12}>
									<Form.Item label={"ประเภทการมอบอำนาจ"}>
										{ this.props.form.getFieldDecorator("docType", {
											initialValue: "LEAVE",
										})(
											<Select 
												style={{ width: "100%" }}
												showSearch
												placeholder=""
												optionFilterProp="children"
											>
												<Option value={"LEAVE"}>การลา</Option>
											</Select>
										)}
									</Form.Item>
								</Col> */}
								<Col xs={ 24 } md={12}>
                                    <Form.Item label={"สถานะ"}>
										{ this.props.form.getFieldDecorator("isActive", {
											initialValue: null,
										})(
											<Select 
												style={{ width: "100%" }}
												showSearch
												placeholder=""
												optionFilterProp="children"
											>
												<Option value={null}>ทั้งหมด</Option>
												<Option value={1}>กำลังใช้งาน</Option>
												<Option value={0}>ถูกยกเลิกแล้ว</Option>
												<Option value={2}>ครบกำหนด</Option>
											</Select>
										)}
									</Form.Item>
								</Col>
								
								<Col xs={24} md={24} align={"right"}>
									<Button 
										type="primary" 
										id="btn-onsearch" 
										className="ml-2 color-white" 
										htmlType="submit" 
										disabled={preLoadSubmit}
									>
										ค้นหา
									</Button>
									{
										preLoadSubmit &&
										<Spin size="small" />
									}
								</Col>
							</Row>
						</Form>
					</div>
					<div className="px-5 py-1 card-bg-green">
						<Row gutter={16} type="flex" justify="left" align="top" className="box-color-white" >
							<Col xs={24} md={12} className="pt-3">
								<strong className="color-red">
									รายการมอบอำนาจการอนุมัติ
								</strong>
							</Col>
                            <Col 
                                xs={24} md={12} 
                                className="pt-2" 
                                align={"right"}
                            >
                                <Button 
                                    type="primary" 
                                    id="btn-onsearch" 
                                    className="ml-2 color-white " 
                                    htmlType="submit" 
									         onClick={ this.showModalFormCreate }
                                >
                                    เพิ่มมอบอำนาจการอนุมัติ
                                </Button>
							</Col>
							<Col xs={ 24 } md={24} className="mb-4 mt-3">
								<Table
									dataSource={dataTalbe} 
									columns={columns} 
									loading={loading}
									pagination={{ pageSize: dataTalbe.length }}
									locale={{ emptyText: 'ไม่พบข้อมูล' }}
									// scroll={{ x: '1320',y: 600 }}
									scroll={{ x: 'max-content' }}
								/>
							</Col>
						</Row>
					</div>
				</div>
			</Container>
		)
	}
}

Delegate.defaultProps = {
	autoFocus: false
}

Delegate.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedDelegate = Form.create()(Delegate)

export default withApollo(WrappedDelegate)